import { BaseClient } from '../BaseClient';
import { Bool, type Empty } from '../compiled-protos/common';
import {
  QBExchangeCodeRequest,
  QBGetAuthURLRequest,
  QBGetAuthURLResponse,
  QBHealthStatus,
} from '../compiled-protos/quickbooks';
import { QuickBooksServiceClient } from '../compiled-protos/quickbooks.client';

class QuickBooksClient extends BaseClient {
  self: QuickBooksServiceClient;

  constructor(host: string, userID?: number) {
    super(host, userID);
    this.self = new QuickBooksServiceClient(this.transport);
  }

  public async GetAuthURL(req: QBGetAuthURLRequest) {
    let res = QBGetAuthURLResponse.create();
    try {
      res = await this.self.getAuthURL(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async ExchangeCode(req: QBExchangeCodeRequest) {
    let res = Bool.create();
    try {
      res = await this.self.exchangeCode(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async GetHealthStatus(req: Empty) {
    let res = QBHealthStatus.create();
    try {
      res = await this.self.getHealthStatus(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }
}

export {
  QBExchangeCodeRequest,
  QBGetAuthURLRequest,
  QBGetAuthURLResponse,
  QBHealthStatus,
  QuickBooksClient,
};
